// extracted by mini-css-extract-plugin
export default {"img":"imageSlider_img__PGFm0","img-cover":"imageSlider_img-cover__Rsd7H","image-carousel":"imageSlider_image-carousel__1pTDS"};